import { AccountCircle, Email, Person, Phone } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'

import type { Appointment } from '../../types.ts'
import { formatCustomerInfo } from '../formaters.ts'
import Header from '../Header'

interface Props {
  appointment: Appointment
}

export const SectionCustomer = ({ appointment }: Props) => {
  return (
    <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 45%' } }}>
      <Header label="Customer Information" />

      <Stack spacing={2}>
        <Box display="flex" alignItems="center" gap={1}>
          <AccountCircle color="action" />
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Account ID
            </Typography>
            <Typography
              variant="body2"
              color={!appointment.customerAccountUUID ? 'text.secondary' : 'text.primary'}
            >
              {appointment.customerAccountUUID || 'Not provided'}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Person color="action" />
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Name
            </Typography>
            <Typography
              variant="body2"
              color={
                formatCustomerInfo(appointment.customerName) === 'Not provided'
                  ? 'text.secondary'
                  : 'text.primary'
              }
            >
              {formatCustomerInfo(appointment.customerName)}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Phone color="action" />
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Phone
            </Typography>
            <Typography
              variant="body2"
              color={
                formatCustomerInfo(appointment.customerPhone) === 'Not provided'
                  ? 'text.secondary'
                  : 'text.primary'
              }
            >
              {formatCustomerInfo(appointment.customerPhone)}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Email color="action" />
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Email
            </Typography>
            <Typography
              variant="body2"
              color={
                formatCustomerInfo(appointment.customerEmail) === 'Not provided'
                  ? 'text.secondary'
                  : 'text.primary'
              }
            >
              {formatCustomerInfo(appointment.customerEmail)}
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  )
}

export default SectionCustomer
